// import camelcaseKeys from "camelcase-keys";
import snakeCaseKeys from "snakecase-keys";

import {
  onDoGetAllInvoices,
  onGetInvoicesPage,
  onUpdateInvoice,
} from "../../services/apis/invoice";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetInvoicesPage = createAsyncThunk(
  "invoice/doGetInvoicesPage",
  async (params, { dispatch }) => {
    const request = snakeCaseKeys(params);
    Object.keys(request).forEach(
      k =>
        (request[k] =
          typeof request[k] == "string"
            ? request[k].trim().replaceAll(/"/g, '"').replaceAll(/\\/g, "\\\\")
            : request[k])
    );
    const result = await onGetInvoicesPage(request);
    if (!result) {
      return;
    }
    dispatch(setNumberOfElements(result.numberOfElements));
    return result;
  }
);

export const doGetAllInvoices = createAsyncThunk(
  "invoice/doGetAllInvoices",
  async params => {
    const result = await onDoGetAllInvoices(params);
    if (!result) {
      return;
    }
    return result;
  }
);
export const doUpdateInvoices = createAsyncThunk(
  "invoices/doUpdateInvoices",
  async params => {
    const result = await onUpdateInvoice(params);
    if (!result) {
      return;
    }
    return result;
  }
);

// export const doGetInvoice = createAsyncThunk(
//   "invoice/doGetInvoice",
//   async params => {
//     const result = await onGetInvoice(params);
//     if (!result) {
//       return;
//     }
//     return camelcaseKeys(result);
//   }
// );

const initialState = {
  isSaving: false,
  list: [],
};

const slice = createSlice({
  name: "invoice",
  initialState: initialState,
  reducers: {
    setNumberOfElements: (state, action) => {
      state.numberOfElements = action.payload;
    },
  },
  extraReducers: {
    [doGetInvoicesPage.pending]: state => {
      state.isSaving = true;
    },
    [doGetInvoicesPage.fulfilled]: (state, action) => {
      state.isSaving = false;
      state.list = action.payload;
    },
    [doGetInvoicesPage.rejected]: state => {
      state.isSaving = false;
      state.list = [];
    },
    [doUpdateInvoices.pending]: state => {
      state.isSaving = true;
    },
    [doUpdateInvoices.fulfilled]: state => {
      state.isSaving = false;
    },
    [doUpdateInvoices.rejected]: state => {
      state.isSaving = false;
    },
  },
});

const { reducer, actions } = slice;
const { setNumberOfElements } = actions;

export default reducer;

export const isSaving = createSelector(
  state => state.invoice.isSaving,
  isSaving => isSaving
);

export const numOfEls = createSelector(
  state => state.invoice.numberOfElements,
  numberOfElements => numberOfElements
);
